import Error from 'routes/Error'

export default Error
